import { coinDesc } from '@/api/const';

export default {
  namespaced: true,
  state: {
    currency: 'USD',
    slot1Menu: [
      ['Unit Price', ' ', item => item.daily.preHalving.cost * coinDesc[item.coin].unitFactor],
      ['Total Cost', '', item => item.total.cost],
      ['Daily Income', '', item => item.daily.preHalving.payoff * item.size],
      ['Total Income', '', item => item.total.payoff]
    ],
    slot1: ['Unit Price', ' ', item => item.daily.preHalving.cost * coinDesc[item.coin].unitFactor],
    slot2Menu: [
      ['ROI', item => item.total.roi],
      ['Breakeven Days', item => item.breakevenDays, 'breakeven'],
      ['Premium/Discount', 'discount']
    ],
    slot2: ['ROI', item => item.total.roi]
  },
  mutations: {
    selectSlot(state, { slot, idx }) {
      state[`slot${slot}`] = state[`slot${slot}Menu`][idx];
    },
    setCurrency(state, currency) {
      state.currency = currency;
    }
  }
};